import api from '../../../services/api';

const API_URL = '/api/v1/manager/audit';

/**
 * @returns {Promise<ApiManager.GetAllAuditBidsResponse>}
 */
export const getAllAuditBids = () => api.get(`${API_URL}`);

/**
 * @param {string} profileId
 */
export const DownloadManagerAuditReport = (profileId) => api.post(
    `${API_URL}/bidProfile/${profileId}/Manager/excel`,
    null,
    { headers: { 'Content-Type': 'blob' }, responseType: 'arraybuffer' },
);

/**
 * @param {string} profileId
 */
export const DownloadEmployeeAuditReport = (profileId) => api.post(
    `${API_URL}/bidProfile/${profileId}/Employee/excel`,
    null,
    { headers: { 'Content-Type': 'blob' }, responseType: 'arraybuffer' },
);
